import React from 'react';
import { Label, Select, ErrorText } from '../libCategoria';

const SelectCategoria = React.forwardRef((props, ref) => {
    const { name, options, defaultValue, error, onChange, ...rest } = props;

    return (
        <div>
            <Select name={name} ref={ref} defaultValue={defaultValue || ''} onChange={onChange} {...rest}>
                <option value={''}> {defaultValue || 'Seleccionar'} </option>
                {options && options.map((option, key) => <option key={key} value={option.value}> {option.label} </option>)}
            </Select>
            {error && <ErrorText>{error}</ErrorText>}
        </div>
    )
});

export default SelectCategoria;
